module.exports = __webpack_public_path__ + "media/images/logos/clubpilates-logo-98b260d526f0319bcf014a67af2205ac.svg";